module.exports = __webpack_public_path__ + "static/TiemposTextWeb-Regular-25c3711dada0db2c9a3b79b4cf359d29.woff";